import { useDispatch, useSelector } from "react-redux"
import { getCustomInterest } from "reducers/userInfo"
import { updateCustomInterest } from "actions/userActions"
import { useForm } from "react-hook-form"
import { FleLayout } from "components/views/fle/FleLayout"
import { Form } from "components/views/atoms/forms/Form"
import { TopSection } from "components/views/fle/TopSection"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "components/views/fle/Molecules"
import { HelperText, Spacer } from "components/views/atoms/Atoms"
import { H4 } from "@carrotfertility/carotene"
import { CompleteFormTextArea } from "components/views/atoms/forms/FormTextArea"
import { FleLinkWrapper } from "components/views/atoms/Links"
import React from "react"
import L10n from "lib/carrot-l10n"
import { JourneyPaths } from "./JourneyPaths"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const JourneySomethingElseContainer = ({ title, helperText, history }) => {
  const customInterest = useSelector(getCustomInterest)
  const dispatch = useDispatch()

  const submitCustomInterest = async (data) => {
    await dispatch(updateCustomInterest(data.customInterest))
    history.push(JourneyPaths.DONE)
  }

  const { register, handleSubmit, errors } = useForm()
  return (
    <FleLayout>
      <Form onSubmit={handleSubmit(submitCustomInterest)}>
        <TopSection progressStep={4} leftOrBackArrow={<BackArrow />} />
        <SwitchH2ToBodyLarge>{title}</SwitchH2ToBodyLarge>
        <Spacer height={0.25} />
        <HelperText>{helperText}</HelperText>
        <Spacer height={2} />
        <H4 variant="dark">{l`SOMETHING ELSE`}</H4>
        <Spacer height={0.5} />
        <CompleteFormTextArea
          name={"customInterest"}
          errors={errors}
          ref={register({
            required: "This field cannot be left blank",
            pattern: {
              value: /\S/,
              message: "This field cannot be left blank"
            }
          })}
        />
        <FleLinkWrapper>
          <ContinueArrow onClick={handleSubmit(submitCustomInterest)} />
        </FleLinkWrapper>
      </Form>
    </FleLayout>
  )
}

export { JourneySomethingElseContainer }
